// extracted by mini-css-extract-plugin
export var disabled = "_b-5";
export var error = "_b-1";
export var fitContent = "_b-6";
export var hasSuffix = "_b-4";
export var iconWrapper = "_b-b";
export var infoIconWrapper = "_b-d _b-b";
export var input = "_b-a";
export var inputWrapper = "_b-0";
export var large = "_b-8";
export var leadingIconWrapper = "_b-c _b-b";
export var measureBox = "_b-e";
export var medium = "_b-7";
export var readonly = "_b-2";
export var small = "_b-3";
export var suffix = "_b-9";